import { render } from "./ExpenseItem.vue?vue&type=template&id=54204f3a"
import script from "./ExpenseItem.vue?vue&type=script&lang=js"
export * from "./ExpenseItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__